export default "__VITE_ASSET__CTND8SN8__"